import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../../components/utils/portal/loading/Loading";
import Error from "../../../../components/utils/portal/error/Error";
import { getDataBlogsDetails } from "../../../../app/blogs/blogsSlice";

function BlogsDetailsSection() {
  const { id } = useParams();
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const { isLoading, blogsDetails, error } = useSelector((state) => state.blogs);

  useEffect(() => {
    dispatch(getDataBlogsDetails(id));
  }, [dispatch, id]);

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return <Error error={error} />;
  }

  return (
    <section className="newsDetails">
      <Container>
        <div className="newsDetails_content">
          <span className="newsDetails_content_date">{blogsDetails?.result?.createdDate}</span>
          <h2 className="newsDetails_content_title">
            {i18n.language === "en" ? blogsDetails?.result?.titleEn : blogsDetails?.result?.titleAr}
          </h2>

          {/* <p className="newsDetails_content_desc" dangerouslySetInnerHTML={{ __html: i18n.language === "en" ? newsDetails?.result?.shortDescriptionEn : newsDetails?.result?.shortDescriptionAr }} /> */}

          <img src={blogsDetails?.result?.image} className="newsDetails_content_img" />
          <p className="newsDetails_content_desc" dangerouslySetInnerHTML={{ __html: i18n.language === "en" ? blogsDetails?.result?.descriptionEn : blogsDetails?.result?.descriptionAr }} />
          {blogsDetails?.result?.blogsSideSection && <Row className="mt-4">
            <Col lg={8} className="order-lg-1 order-2">
              <div className="newsDetails_contentBox">
                <h3 className="newsDetails_contentBox_title">
                  {i18n.language === "en"
                    ? blogsDetails?.result?.blogsSideSection.titleEn
                    : blogsDetails?.result?.blogsSideSection.titleAr}
                </h3>
                <p className="newsDetails_content_desc" dangerouslySetInnerHTML={{ __html: i18n.language === "en" ? blogsDetails?.result?.blogsSideSection.descriptionEn?.replace(/<p>(&nbsp;|\s|<br\s*\/?>)*<\/p>/g, "") : blogsDetails?.result?.blogsSideSection.descriptionAr?.replace(/<p>(&nbsp;|\s|<br\s*\/?>)*<\/p>/g, "") }} />


              </div>
            </Col>
            <Col lg={4} className="order-lg-2 order-1 mb-lg-0 mb-3">
              <img src={blogsDetails?.result?.blogsSideSection.image} className="img-fluid" alt="img blogsDetails" />
            </Col>
          </Row>}
        </div>
      </Container>
    </section>
  );
}

export default BlogsDetailsSection;
